module.exports = __webpack_public_path__ + "img/BT_greeting_UK.cc1dd826.svg";